import { css } from 'emotion'
import { Colors, ProfileName, XSmall, Easings, Link } from '..'

export const AccountStyle = (open, picture) => css({
  position: 'relative',
  display: 'inline-block',
  verticalAlign: 'middle',
  lineHeight: 1.2,
  height: 80,
  cursor: 'pointer',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 6,
    background: '#000',
    transition: `transform 200ms ${Easings.customEase} `,
    transform: `scaleX(${open ? 1 : 0})`,
    transformOrigin: 'center left',
  },
  '.account-card':{
    '&--inner': {
      height: 80,
    },
    '&--picture': {
      overflow: 'hidden',
      width: 60,
      height: 60,
      lineHeight: '60px',
      textAlign: 'center',
      background: picture === '' ? 'black' : `url(${picture}) no-repeat center`,
      backgroundSize: 'cover',
      borderRadius: 9999,
      '@media (min-width: 1224px)': {
        width: 40,
        height: 40,
        lineHeight: '40px',
        backgroundSize: 'cover',
      },
      'svg': {
        fill: 'white',
        verticalAlign: 'middle',
        display: 'inline-block',
      },
    },
    '&--info': {
      paddingLeft: '1rem',
      maxWidth: 'calc(100% - 60px - 1rem)',
      flexBasis: 'calc(100% - 60px - 1rem)',
      '@media (min-width: 1224px)': {
        minWidth: '100px',
        maxWidth: 'none',
        flexBasis: 'none',
      },
    },
    '&--name': {
      ...ProfileName,
      marginBottom: '0.5rem',
      'svg': {
        transform: 'scale(1.5)',
        transformOrigin: 'center center',
        marginLeft: '0.5rem',
        verticalAlign: 'middle',
        transition: 'transform 200ms ease',
        '@media (min-width: 1224px)': {
          transform: `rotate(${open ? -90 : 90}deg)`,
        },
      }
    },
    '&--type': {
      ...XSmall,
      color: Colors.red,
    }
  },
  '.account-panel': {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 4,
    width: '100%',
    height: '100%',
    overflow: 'auto',
    transition: `transform 300ms ${Easings.customEase} ${ open ? 0 : 300}ms, visibility 0ms ease ${ open ? 0 : 600}ms`,
    background: 'white',
    cursor: 'default',
    // paddingTop: 80,
    zIndex: 2,
    transform: `translateX(${open ? 0 : 100}%)`,
    visibility: open ? 'visible' : 'hidden',
    '@media (min-width: 1224px)': {
      position: 'absolute',
      bottom: 0,
      top: 'auto',
      left: 0,
      zIndex: 4,
      width: 260,
      maxHeight: 220,
      height: 'auto',
      padding: '0.5rem',
      transform: `translateY(100%) scaleY(${open ? 1 : 0})`,
      visibility: open ? 'visible' : 'hidden',
      transformOrigin: 'top center',
      boxShadow: `0 5px 20px 0 ${Colors.shadow}`,

    },
    'ul': {
      opacity: open ? 1 : 0,
      transition: `opacity 300ms ease ${ open ? 300 : 0}ms`,
      padding: '2rem 1rem',
      '@media (min-width: 1224px)': {
        padding: 0,
      }
    },
    'a': {
      ...Link,
      fontSize: '1.125rem',
      color: Colors.mediumGrey,
      display: 'block',
      padding: '1rem',
      '@media (min-width: 1224px)': {
        ...Link,
        padding: '0.5rem 1rem',
      },
      '&:hover': {
        color: 'black',
      },
      '&:active': {
        color: Colors.red,
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/account.js